<template>
    <form class="g pop-up-inner"
        :style="{
            width: content.width +'px'
        }"
    >
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="content.caption || '詳細資料'"
            :minorCaption="content.minorCaption || ''"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="md form-table">
                    <table>
                        <template v-for="$title in title">
                            <tr :key="$title.prop" v-if="$title.visible && $title.prop !== 'func'">
                                <th><label :for="$title.prop">{{ $title.caption }}</label></th>
                                <td v-if="$title.editable">
                                    <template
                                        v-if="$title.inputtype === 'number'"
                                    >
                                        <div class="cp input number" :class="[errors.has($title.prop)? 'is-error': '']" :data-error="errors.first($title.prop)">
                                            <input v-model="result[$title.prop]" type="number" v-validate="$title.validate || ''" :name="$title.prop" :id="$title.prop">
                                        </div>
                                    </template>
                                    <template
                                        v-else-if="$title.inputtype === 'boolean'"
                                    >
                                        <div class="cp input radio">
                                            <span>
                                                <input type="radio" :id="$title.prop +'-lock'" :value="true" v-model="result[$title.prop]">
                                                <label :for="$title.prop +'-lock'">是</label>
                                            </span>
                                            <span>
                                                <input type="radio" :id="$title.prop + '-unlock'" :value="false" v-model="result[$title.prop]">
                                                <label :for="$title.prop + '-unlock'">否</label>
                                            </span>
                                        </div>
                                    </template>
                                    <template
                                        v-else-if="$title.inputtype === 'color'"
                                    >
                                        <div class="cp input color" :class="[errors.has($title.prop)? 'is-error': '']" :data-error="errors.first($title.prop)">
                                            <input v-model="result[$title.prop]" type="color" v-validate="$title.validate || ''" :name="$title.prop" :id="$title.prop">
                                        </div>
                                    </template>
                                    <template
                                        v-else-if="$title.inputtype === 'month'"
                                    >
                                        <cpDatePicker
                                            type="month"
                                            :hideLabel="true"
                                            :errorStatus="errors.has($title.prop)"
                                            :errorMsg="errors.first($title.prop)"
                                            v-model="result[$title.prop]"
                                            v-validate="$title.validate || ''"
                                            :name="$title.prop"
                                            :ref="$title.prop"
                                        ></cpDatePicker>
                                    </template>
                                    <template
                                        v-else-if="$title.inputtype === 'date'"
                                    >
                                        <cpDatePicker
                                            type="date"
                                            :hideLabel="true"
                                            :errorStatus="errors.has($title.prop)"
                                            :errorMsg="errors.first($title.prop)"
                                            v-model="result[$title.prop]"
                                            v-validate="$title.validate || ''"
                                            :name="$title.prop"
                                            :ref="$title.prop"
                                        ></cpDatePicker>
                                    </template>
                                    <template
                                        v-else-if="$title.options && $title.options.length"
                                    >
                                        <div class="cp input select" :class="[errors.has($title.prop)? 'is-error': '']" :data-error="errors.first($title.prop)">
                                            <select v-model="result[$title.prop]" v-validate="$title.validate || ''" :name="$title.prop" :id="$title.prop">
                                                <option value="">請選擇</option>
                                                <option v-for="item in $title.options || []" :key="item" :value="item">{{item}}</option>
                                            </select>
                                        </div>
                                    </template>
                                    <template
                                        v-else
                                    >
                                        <div class="cp input text" :class="[errors.has($title.prop)? 'is-error': '']" :data-error="errors.first($title.prop)">
                                            <input v-model="result[$title.prop]" type="text" v-validate="$title.validate || ''" :name="$title.prop" :id="$title.prop">
                                        </div>
                                    </template>
                                </td>
                                <td v-else-if="content.disabled === false">
                                    <div class="cp input text" :class="[errors.has($title.prop)? 'is-error': '']" :data-error="errors.first($title.prop)" disabled>
                                        <input v-model="result[$title.prop]" type="text" v-validate="''" :name="$title.prop" :id="$title.prop" disabled>
                                    </div>
                                </td>
                                <td v-else>
                                    <div class="cp input text" disabled>
                                        <input :Value="result[$title.prop]" type="text" disabled>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </table>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </form>
</template>

<script>
    import cpDatePicker from '@/components/cpDatePicker'
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'
import { mapMutations } from 'vuex'

    export default {
        components: {
            cpDatePicker,
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            },
        },
        data: function(){
            let $content = this.content,
                $node = $content.node;

            let $clone = this.$okaTool.copy($node);

            delete $clone.show;
            delete $clone.func;
            delete $clone.page;
            delete $clone.sn;

            return {
                result: $clone
            }
        },
        computed: {
            title: function() {
                return this.content.title || []
            },
            haveAction: function() {
                return this.content.action && typeof this.content.action === 'function';
            },
            btns: function(){
                let $content = this.content || {},
                    $moreBtns = $content.moreBtns || []

                let $action = {
                        text: $content.actionName || this.$t('site.status.confirm'),
                        icon: $content.actionIcon || '',
                        themes: $content.actionTheme? $content.actionTheme: 'major',
                        func: 'action',
                    },
                    $cancel = {
                        text: $content.cancelName || this.$t('site.func.popupclose'),
                        icon: $content.cancelIcon || '',
                        themes: $content.cancelTheme || '',
                        func: 'close',
                    }

                let $results = [].concat($moreBtns);

                if( this.haveAction ) {
                    $results.push($action);
                }

                $results.push($cancel);

                return $results;
            },
        },
        methods: {
            ...mapMutations([
                'catchError'
            ]),
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            },
            action: function(){
                let $content = this.content,
                    $_action = $content.action;

                this.$validator.validate().then(result => {
                    if (!result){
                        //啊就沒通過啊
                    }else {
                        let $result = this.result;

                        if( $_action && typeof $_action === 'function' ) {
                            $_action($result);
                            this.close();
                        }
                    }
                }).catch(error => {
                    console.log('error',error)
                    this.catchError({
                        error: error,
                        callback: () => {
                            $_action($result);
                        },
                    });
                });;
            }
        }
    }
</script>

<style scoped lang="scss">
   

</style>    
